export default __webpack_public_path__ + "static/media/ic_comms.481794e5.svg";